<!-- Alert -->
<fuse-alert
    class="auth-fuse-alert sign-up-form-fuse-alert"
    *ngIf="showAlert"
    [appearance]="'outline'"
    [showIcon]="false"
    [type]="alert.type"
    [@shake]="alert.type === 'error'">
    {{ alert.message }}
</fuse-alert>

<!-- Sign Up form -->
<form
    class="auth-form-wrapper-shallow sign-up-form"
    [formGroup]="signUpForm"
    #signUpNgForm="ngForm">

    <!-- Email field -->
    <mat-form-field class="auth-form-field sign-up-email-form-field">
        <mat-label>Email address</mat-label>
        <input
            id="email"
            matInput
            autocomplete="username"
            inputmode="email"
            [formControlName]="'email'">
        <mat-error *ngIf="signUpForm.get('email').hasError('required')">
            Email address is required
        </mat-error>
        <mat-error *ngIf="signUpForm.get('email').hasError('email')">
            Please enter a valid email address
        </mat-error>
    </mat-form-field>

    <!-- Password field -->
    <mat-form-field class="auth-form-field sign-up-password-form-field">
        <mat-label>Password</mat-label>
        <input
            id="password"
            matInput
            type="password"
            autocomplete="new-password"
            [formControlName]="'password'"
            #passwordField>
        <button
            mat-icon-button
            type="button"
            (click)="passwordField.type === 'password' ? passwordField.type = 'text' : passwordField.type = 'password'"
            matSuffix>
            <mat-icon
                class="auth-form-field-icon"
                *ngIf="passwordField.type === 'password'"
                [svgIcon]="'heroicons_solid:eye'"></mat-icon>
            <mat-icon
                class="auth-form-field-icon"
                *ngIf="passwordField.type === 'text'"
                [svgIcon]="'heroicons_solid:eye-slash'"></mat-icon>
        </button>
        <mat-error *ngIf="signUpForm.get('password').hasError('required')">
            Password is required
        </mat-error>
    </mat-form-field>

    <auth-password-strength
        [password]="passwordField.value"
        (validEvent)="checkValidPassword($event)"></auth-password-strength>

    <!-- Submit button -->
    <button
        class="sign-up-form-submit-button fuse-mat-button-large"
        mat-flat-button
        [color]="'primary'"
        [disabled]="signUpForm.disabled || !signUpForm.valid"
        (click)="signUp()">
        <span *ngIf="!signUpForm.disabled">
            Create account
        </span>
        <mat-progress-spinner
            *ngIf="signUpForm.disabled"
            [diameter]="24"
            [mode]="'indeterminate'"></mat-progress-spinner>
    </button>
</form>
